export const createPaymentCardForm = () => {
  const tokenizationSourceKey = process.env.REACT_APP_BANQUEST_PUBLIC_KEY
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const hostedTokenization: HostedTokenization = new window.HostedTokenization(tokenizationSourceKey)
  const cardForm = hostedTokenization.create('card-form')

  return cardForm
}
